import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, type SxProps, type Theme } from '@mui/material';

interface DashboardCardProps {
  children?: React.ReactNode;
  customStyles?: SxProps<Theme>;
  navigation?: string;
  onClick?: () => void;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({
  children,
  customStyles,
  navigation,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (onClick) {
      onClick();
    }
    if (navigation) {
      navigate(navigation);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: 3,
        bgcolor: 'backgroundColors.secondary',
        color: 'inherit',
        padding: 'inherit',
        height: 'inherit',
        borderColor: 'borderColors.primary',
        boxShadow: 'none',
        border: '1px',
        cursor: navigation || onClick ? 'pointer' : 'default',
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...customStyles,
      }}
      onClick={navigation || onClick ? handleNavigation : undefined}
    >
      {children}
    </Box>
  );
};
